var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2001 0C16.5184 0 16.8236 0.126428 17.0486 0.351472C17.2737 0.576515 17.4001 0.88174 17.4001 1.2V9.6H15.0001V2.4H3.0001V21.6H9.0001V24H1.8001C1.48184 24 1.17661 23.8736 0.95157 23.6485C0.726526 23.4235 0.600098 23.1183 0.600098 22.8V1.2C0.600098 0.88174 0.726526 0.576515 0.95157 0.351472C1.17661 0.126428 1.48184 0 1.8001 0H16.2001ZM16.2001 12C17.1549 12 18.0706 12.3793 18.7457 13.0544C19.4208 13.7295 19.8001 14.6452 19.8001 15.6V16.8H21.0001V22.8C21.0001 23.1183 20.8737 23.4235 20.6486 23.6485C20.4236 23.8736 20.1184 24 19.8001 24H12.6001C12.2818 24 11.9766 23.8736 11.7516 23.6485C11.5265 23.4235 11.4001 23.1183 11.4001 22.8V16.8H12.6001V15.6C12.6001 14.6452 12.9794 13.7295 13.6545 13.0544C14.3296 12.3793 15.2453 12 16.2001 12ZM18.6001 19.2H13.8001V21.6H18.6001V19.2ZM16.2001 14.4C15.5905 14.4 15.0001 14.94 15.0001 15.6V16.8H17.4001V15.6C17.4001 15.2817 17.2737 14.9765 17.0486 14.7515C16.8236 14.5264 16.5184 14.4 16.2001 14.4Z",
    fill: "#0E121B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.ca4bcf2598af59b51a26c28a6d2271a8.svg";
export { ForwardRef as ReactComponent };